import { CarUnderuseAnswer, CarUnderuseReason, SearchCarUnderuseAnswerCondition } from "@/models/carUnderuseEvents/answers";
import { Office } from "@/models/office";
import { formatDateStr } from "@/util/datetime";

export const CarUnderuseAnswersConstants = {
  CarUnderuseAnswers: "未稼働理由登録履歴（月次の稼働確認）",
  YearMonth: "年月度",
  CompanyOffice: "会社/営業所",
  RadioNumber: "無線番号",
  UnderuseReason: "未稼働理由",
  RestartPlanDate: "稼働再開予定",
  RestartPlanDetail: "状況と見通しの詳細",
} as const;

export type SavedState = {
  officesSelected: Office[];
  page: number;
  searchCondition: SearchCarUnderuseAnswerCondition;
};

export const PAGE_SIZE = 30;

export const UnderuseReasonLabels: Record<CarUnderuseReason, string> = {
  ACCIDENT_WITH_REPORT: "事故修理（報告フォーム提出済）",
  ACCIDENT_WITHOUT_REPORT: "事故修理（報告フォーム未提出）",
  BREAKDOWN_NOT_ACCIDENT: "事故ではない故障修理",
  OTHER: "事故や故障以外",
};

export const getUnderuseReasonLabel = (code: CarUnderuseReason): string => {
  return UnderuseReasonLabels[code] ?? code;
};

export const getRestartPlanLabel = (answer: CarUnderuseAnswer): string => {
  return answer.restartPlanDate ? formatDateStr(answer.restartPlanDate) : "";
};
